import React from 'react';
import css from './LaborAndToolsItemsTypesSection.module.css';

interface Props {
    children: React.ReactNode;
}

export const LaborAndToolsItemsTypesSection: React.FC<Props> = ({
    children,
}) => {
    return <div className={css.section}>{children}</div>;
};
